:host {
  --cms-default-grid-area: auto / auto / auto / span 12;
  --cms-column-count: 1;
  @include cms-components-host-defaults;
}

.page-list-container {
  @include cms-default-grid-container;
}

.page-list-container>* {
  grid-area: var(--cms-default-grid-area);
}

.page-list-headline {
  @include headline-font-150;
}

.page-list {
  column-count: var(--cms-column-count);
  list-style: none;
  padding: 0;
  margin: 0;
}

.page-list-item {
  padding: 0;
  display: table;
  max-height: fill-available;
  margin-bottom: var(--cms-spacing-050);
}

.page-link {
  padding: var(--cms-spacing-025) 0;
  @include cms-anchor-base-font;
}

@include media-width($breakpoint-xs) {
  .page-list {
    --cms-column-count: 2;
  }
}

@include media-width($breakpoint-sm) {
  .page-list {
    --cms-column-count: 3;
  }
}

@include media-width($breakpoint-md) {
  .page-list {
    --cms-column-count: 4;
  }
}